export type SidebarItemKey =
  | 'telephony'
  | 'domainsDns'
  | 'emails'
  | 'webDatabase'
  | 'marketplace'
  | 'infrastructureVps'
  | 'infrastructureDedicated'
  | 'divops';

// Clé = typologie client (en minuscules), valeur = items de menu à cacher pour ce type de client.
// 'default' s'applique à tout client dont la typologie n'a pas d'entrée dédiée ci-dessous
// (donc à tous les clients non-divop aujourd'hui). Pour ajouter une règle pour un type de
// client précis, ajouter une entrée ici — aucune modification du JSX du menu n'est nécessaire.
export const HIDDEN_SIDEBAR_ITEMS_BY_CLIENT_TYPE: Record<string, SidebarItemKey[]> = {
  default: ['divops'],
  divop: [
    'telephony',
    'domainsDns',
    'emails',
    'webDatabase',
    'marketplace',
    'infrastructureVps',
    'infrastructureDedicated',
  ],
};

export const isSidebarItemHiddenForClientType = (
  item: SidebarItemKey,
  clientType?: string | null
): boolean => {
  const key = clientType?.toLowerCase() ?? 'default';
  const hiddenItems =
    HIDDEN_SIDEBAR_ITEMS_BY_CLIENT_TYPE[key] ?? HIDDEN_SIDEBAR_ITEMS_BY_CLIENT_TYPE.default;
  return hiddenItems.includes(item);
};
